import React, {useState, useEffect, useLayoutEffect} from 'react';
import {motion} from 'framer-motion';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import ContactHeroBit from '../components/contact/ContactHeroBit';
import ContactFormBit from '../components/contact/ContactFormBit';
import SupportInfoBit from '../components/contact/SupportInfoBit';
import QuickHelpBit from '../components/contact/QuickHelpBit';
import BrandSupportMessage from '../components/contact/BrandSupportMessage';
import '../styles/globals.css';
import '../styles/contact.css';
import {pageTransition} from "../components/animations/animations";

const ContactPage = () => {
    const [isMobile, setIsMobile] = useState(false);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.div
            variants={pageTransition}
            initial="initial"
            animate="animate"
            exit="exit"
            className="min-h-screen bg-gradient-to-b from-pearl via-pearl to-nude/10"
        >
            <Navbar/>

            <main className="relative min-h-screen lg:min-h-[90vh] overflow-hidden pt-20">
                <div className="container-luxury">
                    {/* Header */}
                    <div className="mb-8 md:mb-12">
                        <ContactHeroBit isMobile={isMobile}/>
                    </div>

                    {/* Main Content Grid */}
                    <div className="grid lg:grid-cols-3 gap-8 lg:gap-12">
                        {/* Left Column: Form */}
                        <div className="lg:col-span-2">
                            <motion.div
                                initial={{opacity: 0, y: 20}}
                                animate={{opacity: 1, y: 0}}
                                transition={{delay: 0.2}}
                            >
                                <ContactFormBit isMobile={isMobile}/>
                            </motion.div>

                            {/* Quick Help */}
                            <motion.div
                                initial={{opacity: 0, y: 20}}
                                animate={{opacity: 1, y: 0}}
                                transition={{delay: 0.4}}
                                className="mt-12"
                            >
                                <QuickHelpBit isMobile={isMobile}/>
                            </motion.div>
                        </div>

                        {/* Right Column: Support Info */}
                        <div className="lg:col-span-1">
                            <motion.div
                                initial={{opacity: 0, x: 20}}
                                animate={{opacity: 1, x: 0}}
                                transition={{delay: 0.3}}
                            >
                                <SupportInfoBit isMobile={isMobile}/>
                            </motion.div>
                        </div>
                    </div>

                    {/* Brand Message */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: 0.5}}
                        className="mt-16 md:mt-24"
                    >
                        <BrandSupportMessage isMobile={isMobile}/>
                    </motion.div>
                </div>
            </main>

            <Footer/>
        </motion.div>
    );
};

export default ContactPage;